module.exports = __webpack_public_path__ + "static/scale-model-of-sports-groups-international-in-worcester-massachusetts-1c72eabdbbfdb0d7d001f446d4dd6c04.png";